import React from 'react';
import styled from 'styled-components';
import { GridSection, Eyebrow, SectionTitle } from './GridSection';

const Prose = styled.div`
  p {
    font-size: 1.12rem;
    line-height: 1.7;
    color: var(--ink);
    margin: 0 0 18px;
  }
`;

function About() {
  return (
    <GridSection id="about">
      <Eyebrow>i — about</Eyebrow>
      <SectionTitle>About.</SectionTitle>
      <Prose>
        <p>
          From Karachi. Studied CS at Habib University. A couple of years writing backend
          at BlueLake; a shorter stretch at Trinity Life Sciences after that. Now in New
          York, finishing a master's at NYU Tandon. The thesis is on self-supervised
          learning for autonomous driving — pretraining on unlabeled driving video to see
          whether a planner trained in one city generalizes to another.
        </p>
        <p>
          Looking for what's next. Senior SWE or ML.
        </p>
      </Prose>
    </GridSection>
  );
}

export default About;
